import React, { Component } from 'react';

class IconSearch extends Component {
    render() {
        return (
          <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>Search</title>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <g id="icon_search" transform="translate(-7.000000, -7.000000)" stroke="#000000" strokeWidth="2">
                <path d="M23.864125,23.864125 L31.5,31.5 L23.864125,23.864125 C22.2355,25.49275 19.9855,26.5 17.5,26.5 C12.529,26.5 8.5,22.471 8.5,17.5 C8.5,12.529 12.529,8.5 17.5,8.5 C22.471,8.5 26.5,12.529 26.5,17.5 C26.5,19.9855 25.49275,22.2355 23.864125,23.864125 Z" id="Combined-Shape"/>
              </g>
            </g>
          </svg>
        )
    }
}

export default IconSearch;